/*
  Unauthorized.js
  ---------------
  Purpose: This page displays an access denied message to users who attempt to access restricted areas without proper authorization. It provides clear feedback and navigation options for users with insufficient permissions.

  Main Logic:
  - Renders a user-friendly unauthorized access message.
  - Provides navigation back to the login page or other safe areas.
  - Utilizes shared layout components for consistent UI.
*/

import React from 'react'
import NavBar from "../components/NavBar";
import { Container } from 'react-bootstrap';


function Unauthorized() {
  return (
    <>
    <NavBar/>
    <Container style={{height:"100vh" , width:"100vw"}}  className='d-flex flex-column justify-content-center align-items-center '>
        <h1>Unauthorized access!</h1>
        <h3>Please contact your Admin</h3>
        <br />
        <h3><a href="/">Go to login</a></h3>
    </Container>
    </>
  )
}

export default Unauthorized